import DeliverySettings from './DeliverySettings.view';

export default DeliverySettings;
